import React from 'react';
import { useMount, useUnmount } from 'react-use';

import styles from './MainLayout.scss';

export default function MainLayout({ children }) {
    useMount(() => {
        document.documentElement.classList.add(styles.html);
    });

    useUnmount(() => {
        document.documentElement.classList.remove(styles.html);
    });

    return (
        <div className={styles.root}>
            <div className={styles.container}>{children}</div>
        </div>
    );
}
